import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { IEnrichedFlight } from '../../../shared/flight/domain/models/IEnrichedFlight';

const AMOUNT_OF_HASH_PARTS = 6;

enum ArrivalStatus {
	Arrival = 'arrival',
	Departure = 'departure',
}

export function useUrlForFlightDetails(flight: IEnrichedFlight) {
	const {
		arrival,
		scheduledDate,
		departureAirport,
		viaAirport,
		arrivalAirport,
		codeShareFlightNumber,
	} = flight;

	const type = arrival ? ArrivalStatus.Arrival : ArrivalStatus.Departure;

	const parts = [
		type,
		scheduledDate,
		departureAirport,
		viaAirport,
		arrivalAirport,
		codeShareFlightNumber,
	];

	const path = useUrlForPageId(PassengersPageId.FlightDetail);
	const hash = `/${parts.join('/')}`;

	return `${path}#${hash}`;
}

export function parseFlightDetailsHash(hash: string | undefined) {
	if (!hash) {
		return false;
	}

	// Split the hash and filter out empty strings
	const parts = hash.split('/').filter((part) => part);

	// Consider the hash invalid if it doesn't contain the right amount of elements.
	if (parts.length !== AMOUNT_OF_HASH_PARTS) {
		return false;
	}

	// Assign values
	const arrival = parts[0] === ArrivalStatus.Arrival;
	const scheduledDate = parts[1];
	const departureAirport = parts[2];
	const viaAirport = parts[3];
	const arrivalAirport = parts[4];
	const codeShareFlightNumber = parts[5];

	return {
		arrival,
		scheduledDate,
		departureAirport,
		viaAirport,
		arrivalAirport,
		codeShareFlightNumber,
	};
}
